import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=b5c39a96&scoped=true"
var script = {}
import style0 from "./Default.vue?vue&type=style&index=0&id=b5c39a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c39a96",
  null
  
)

export default component.exports